import React from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LucideIcon } from "lucide-react";

interface FormFieldProps {
  name: string;
  label: string;
  icon?: LucideIcon;
  type?: string;
  placeholder?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  name,
  label,
  icon: Icon,
  type = "text",
  placeholder,
}) => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="form-group">
      <Label className="form-label flex items-center gap-2">
        {Icon && <Icon size={16} />}
        {label}
      </Label>
      <Input
        {...register(name)}
        type={type}
        placeholder={placeholder}
        className="form-input"
      />
      {errors[name] && (
        <p className="text-sm text-red-600">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default FormField; 